import { Link } from 'react-router-dom';
import { toFullUrl } from '../../config/api';
import { Headphones } from 'lucide-react';
import { Button } from '../ui/button';

export function BeatsSection({ beats, siteSettings, onBeatLicense, isVisible }) {
  if (!isVisible('beats') || beats.length === 0) return null;

  return (
    <section className="border-t border-[#262626] py-16 sm:py-24 px-4 sm:px-8" data-testid="beats-section" id="beats">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <div>
            <p className="overline text-[var(--primary,#FF3B30)] mb-2">{siteSettings?.section_titles?.beats_label || 'PRODUCERS'}</p>
            <h2 className="font-cabinet text-3xl sm:text-4xl font-black uppercase tracking-tighter">
              {siteSettings?.section_titles?.beats || 'SLAP SECTION'}
            </h2>
          </div>
          <Headphones className="w-8 h-8 text-[var(--primary,#FF3B30)]" />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {beats.slice(0, 5).map(beat => (
            <div key={beat.id} className="group" data-testid={`beat-${beat.id}`}>
              <Link to="/beats" className="block">
                <div className="aspect-square bg-[#0A0A0A] border border-[#262626] overflow-hidden group-hover:border-[var(--primary,#FF3B30)] transition-colors relative">
                  {beat.cover_image ? (
                    <img src={toFullUrl(beat.cover_image)} alt={beat.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <Headphones className="w-10 h-10 text-[#262626]" />
                    </div>
                  )}
                  {beat.license_basic > 0 && (
                    <div className="absolute bottom-2 right-2 bg-[#0A0A0A]/90 border border-[var(--primary,#FF3B30)] px-2 py-1" data-testid={`beat-price-${beat.id}`}>
                      <span className="text-xs font-bold text-[var(--primary,#FF3B30)] font-mono">
                        {beat.on_sale && beat.sale_price_basic ? `$${beat.sale_price_basic}` : `$${beat.license_basic}`}
                      </span>
                    </div>
                  )}
                </div>
              </Link>
              <div className="mt-2 flex items-start justify-between gap-2">
                <Link to="/beats" className="flex-1 min-w-0">
                  <h3 className="font-cabinet font-bold uppercase text-sm truncate group-hover:text-[var(--primary,#FF3B30)] transition-colors">{beat.title}</h3>
                  <p className="text-[#666] text-xs">{beat.producer}{beat.bpm ? ` · ${beat.bpm} BPM` : ''}</p>
                </Link>
                {beat.license_basic > 0 && (
                  <button onClick={() => onBeatLicense(beat, 'basic')}
                    className="shrink-0 px-2 py-1 bg-[var(--primary,#FF3B30)] hover:bg-white hover:text-[#0A0A0A] text-[10px] font-bold uppercase transition-colors"
                    data-testid={`buy-beat-${beat.id}`}>
                    BUY
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center pt-6">
          <Link to="/beats" data-testid="view-all-beats-btn">
            <Button variant="outline" className="rounded-none border-[var(--primary,#FF3B30)] text-[var(--primary,#FF3B30)] hover:bg-[var(--primary,#FF3B30)] hover:text-white px-8 py-3 text-sm font-bold uppercase tracking-wider">
              VIEW ALL {siteSettings?.section_titles?.beats || 'BEATS'}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
